<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background" v-show="showLoadingScreen" aria-hidden="true">

  		<img class="loader-img" alt="Odense Rundt logo" src="@/assets/img/loading-logo.png" />
  		<svg class="loader-circle">
  			<circle class="path" cx="45" cy="45" r="40" fill="none" stroke-width="2" stroke-miterlimit="10"/>
  		</svg>

    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      showLoadingScreen: false
    }
  },
  created() {
    this.$root.$on('toggleLoadingScreen', (bool) => {
      this.toggleLoadingScreen(bool);
    });
  },
  methods: {
    toggleLoadingScreen(bool) {
      this.showLoadingScreen = (bool == undefined) ? !this.showLoadingScreen : bool;
    },
  }
}
</script>

<style lang="css">
.loader-img {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-left: -35px;
	margin-top: -35px;
	height: 70px;
	width: 70px;
}

.path {
	stroke: #fff;
	stroke-dasharray: 200, 30;
	stroke-dashoffset: 0;
	-webkit-animation-name: dash, color;
	-webkit-animation-duration: 2000ms, 6000ms;
	-webkit-animation-iteration-count: infinite;
	-webkit-animation-timing-function: ease-in-out;
	animation-name: dash, color;
	animation-duration: 2000ms, 6000ms;
	animation-iteration-count: infinite;
	animation-timing-function: ease-in-out;
	stroke-linecap: round;
}

.loader-circle {
	position: absolute;
	top: 50%;
	left: 50%;
	height: 90px;
	width: 90px;
	margin-left: -45px;
	margin-top: -45px;
	-webkit-animation-name: rotate;
	-webkit-animation-duration: 2000ms;
	-webkit-animation-iteration-count: infinite;
	-webkit-animation-timing-function: linear;
	animation-name: rotate;
	animation-duration: 2000ms;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
}

@keyframes rotate {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes color {
	0% {
		stroke: rgb(0,112,141);
	}
	50% {
		stroke: rgb(200,200,200);
	}
	100% {
		stroke: rgb(0,112,141);
	}
}

</style>
